import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  ANAO,
  AOS_ABERTA,
  AOS_CANCELADA
} from 'consts';
import {
  formatDateForInput,
  formatDateText,
  formatTimeText
} from 'lib/functions';
import {
  AppBar,
  Button,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Input,
  InputLabel,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography
} from '@material-ui/core';
import {
  BackspaceOutlined,
  CropFreeRounded,
  FilterListRounded,
  Search,
  SendRounded,
  WhatsApp
} from '@material-ui/icons';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18n from 'translations/langEngine';
import { safeSetState } from 'lib/reactUtils';
import ButtonA2X from 'views/Components/Bottombar';
import { CommonTranslations } from 'translations/translationKeys';
import { getApiErrorMessage, getResponseData } from 'lib/formUtils';
import WhatsAppEstrutura from 'views/CRM/WhatsApp/WhatsAppEstrutura';

function TabContainer(props) {
  return (
    <Typography
      component="div"
      style={{ padding: 8 * 3 }}
    >
      {props.children}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

/* Propriedades padrão dos labels dos filtros de data / hora */
const LABEL_PROPS_FILTRO = {
  shrink: true,
  style: { fontSize: 13 }
};

/* Campos de período da pesquisa */
const CAMPOS_PERIODO = [
  {
    name: 'dataInicialFilter',
    label: 'Data Inicial',
    type: 'date'
  },
  {
    name: 'horaInicialFilter',
    label: 'Hora Inicial',
    type: 'time'
  },
  {
    name: 'dataFinalFilter',
    label: 'Data Final',
    type: 'date'
  },
  {
    name: 'horaFinalFilter',
    label: 'Hora Final',
    type: 'time'
  }
];

/* Opções do filtro de serviços */
const OPCOES_SERVICOS = [
  'IN',
  'OUT',
  'Opcionais',
  'Transporte'
];

/* Filtro de seleção do tipo de data */
const SELECT_TIPO_DATA = {
  name: 'tipoDataFilter',
  label: 'Tipo de Data',
  minWidth: 160,
  options: [
    {
      value: 'dataServico',
      label: 'Data Serviço'
    },
    {
      value: 'dataRegistro',
      label: 'Data Registro'
    }
  ]
};

/* Filtros de seleção da exibição de pax e fone */
const SELECTS_EXIBICAO = [
  {
    name: 'tipoPaxFilter',
    label: 'Exibir Pax',
    minWidth: 10,
    options: [
      {
        value: 'pax',
        label: 'Do serviço'
      },
      {
        value: 'titular',
        label: 'Titular do serviço'
      }
    ]
  },
  {
    name: 'tipoFoneFilter',
    label: 'Exibir fone',
    minWidth: 10,
    options: [
      {
        value: 'pax',
        label: 'de cada pax'
      },
      {
        value: 'os',
        label: 'da OS'
      }
    ]
  }
];

/* Opções do filtro de situação da OS */
const OPCOES_SITUACAO_OS = [
  {
    value: AOS_ABERTA,
    label: 'Abertas'
  },
  {
    value: AOS_CANCELADA,
    label: 'Canceladas'
  },
  {
    value: '',
    label: 'Todas'
  }
];

/* Filtros de texto da pesquisa */
const FILTROS_TEXTO = [
  {
    name: 'nroOSFilter',
    label: 'Nº OS',
    width: 110
  },
  { name: 'escalaFilter', label: 'Escala (ex.: 7,10)', width: 180 },
  { name: 'familiaFilter', label: 'Família (ex.: 1,2)', width: 180 },
  {
    name: 'intervaloItensFilter',
    label: 'Itens da OS (ex.: 7,10,30)',
    width: 210
  }
];

/* Colunas da tabela de passageiros */
const COLUNAS_PASSAGEIROS = [
  'Selecionar',
  'Passageiro',
  'Fone',
  'OS',
  'Data serviço',
  'Hora',
  'Serviço',
  'Hotel',
  'Origem',
  'Status',
  'Grupo mensagem'
];

/* Legenda dos status de envio */
const LEGENDA_STATUS = [
  {
    label: 'Não enviado',
    background: '#fff',
    border: '1px solid #333'
  },
  {
    label: 'Enviado',
    background: '#222'
  },
  {
    label: 'Recebido',
    background: '#168c35'
  }
];

/* Retorna os filtros de pesquisa padrão */
function getSearchFilterDefault() {
  const hoje = formatDateForInput(new Date());

  return {
    tipoDataFilter: 'dataServico',
    tipoPaxFilter: 'pax',
    tipoFoneFilter: 'pax',
    dataInicialFilter: hoje,
    dataFinalFilter: hoje,
    horaInicialFilter: '00:00',
    horaFinalFilter: '23:59',
    situacaoOSFilter: AOS_ABERTA,
    escaladosFilter: 'todos',
    semConfirmacaoPushFilter: false,
    familiaNaoLogadaAppFilter: false,
    nroOSFilter: '',
    dataServicoFilter: '',
    horaServicoFilter: '',
    tipoServicoFilter: '0',
    escalaFilter: '',
    familiaFilter: '',
    codVooFilter: '',
    statusEnvioFilter: 'todos',
    nomePaxFilter: '',
    codServicoFilter: '',
    codHotelFilter: '',
    intervaloItensFilter: '',
    permiteOSSemServico: ANAO
  };
};

class EnvioWhatsAppPassageiroForm extends Component {
  _isMounted = false;
  safeSetState = safeSetState;

  state = {
    activeTab: 0,
    exibirQrCodeZapi: false,
    exibirFiltrosPush: false,
    listasFiltros: { servicos: [], hoteis: [], voos: [] },
    filtrosServicos: [],
    searchFilter: getSearchFilterDefault(),
    translations: {},
    whatsappComposicao: null,
    whatsappDialogEstrutura: false,
    whatsappDialogGrupo: false,
    whatsappEnviando: false,
    whatsappErro: '',
    whatsappGrupos: [],
    whatsappGrupoSelecionado: '',
    whatsappLimitado: false,
    whatsappLoading: false,
    whatsappPreviewLoading: false,
    whatsappResultados: []
  };

  /* Carrega os dados iniciais da tela */
  componentDidMount() {
    this._isMounted = true;

    this.performsTranslation();
    this.carregarGruposWhatsApp();
    this.carregarProvedorWhatsApp();
    this.carregarListasFiltros();
  };

  /* Limpa a flag de montagem ao sair da tela */
  componentWillUnmount() {
    this._isMounted = false;
  };

  /* Realiza a tradução */
  async performsTranslation() {
    const termsNeeded = [CommonTranslations.TABSHEET_GERAL];
    const translations = await i18n.fetchTerms(termsNeeded);

    this.safeSetState({ translations });
  };

  /* Carrega o provedor de WhatsApp configurado no CRM */
  carregarProvedorWhatsApp = async () => {
    try {
      const { data } = await api.get('/crm/configuracoes/geral');

      const exibirFiltrosPush = data.enviapushcomservico === 'S';
      this.safeSetState(prev => ({
        exibirQrCodeZapi: Number(data.provedorwhatsapp) === 1,
        exibirFiltrosPush,
        searchFilter: exibirFiltrosPush ? prev.searchFilter : {
          ...prev.searchFilter,
          semConfirmacaoPushFilter: false,
          familiaNaoLogadaAppFilter: false
        }
      }));
    } catch (error) {
      console.warn('Não foi possível consultar o BSP do CRM:', error);
    }
  };

  carregarListasFiltros = async () => {
    const consultas = [
      ['servicos', '/servico/active/true?limit=1000'],
      ['hoteis', '/hotel/active/true?limit=1000'],
      ['voos', '/voo/active/true']
    ];
    const resultados = await Promise.allSettled(consultas.map(async ([nome, url]) => {
      let response = await api.get(url);
      const registros = [...getResponseData(response)];
      const totalPaginas = Number(response.data?.info?.totalpages || 1);
      for (let page = 2; page <= totalPaginas; page += 1) {
        response = await api.get(`${url}&page=${page}`);
        registros.push(...getResponseData(response));
      }
      this.safeSetState(prev => ({
        listasFiltros: { ...prev.listasFiltros, [nome]: registros }
      }));
    }));
    if (resultados.some(resultado => resultado.status === 'rejected')) {
      this.safeSetState({ whatsappErro: 'Não foi possível carregar todas as listas de filtros. Reabra a tela para tentar novamente.' });
    }
  };

  renderFiltroCadastro = (lista, name, chave, descricao, label) => {
    const options = this.state.listasFiltros[lista];
    const value = options.find(item => String(item[chave]) === String(this.state.searchFilter[name])) || null;
    return <Autocomplete
      options={options}
      value={value}
      getOptionSelected={(option, selected) => String(option[chave]) === String(selected[chave])}
      getOptionLabel={option => `${option[descricao] || ''} [${option[chave]}]`}
      onChange={(event, item) => this.setState(prev => ({
        searchFilter: { ...prev.searchFilter, [name]: item ? item[chave] : '' }
      }))}
      style={{ width: 300, margin: 8 }}
      renderInput={params => <TextField {...params} label={label} placeholder="Todos" InputLabelProps={{ shrink: true }} />}
    />;
  };

  /* Troca a aba ativa */
  handleChangeTab = (event, value) => {
    this.setState({ activeTab: value });
  };

  /* Volta para a aba de filtros */
  handleVoltarFiltros = () => {
    this.setState({ activeTab: 0 });
  };

  /* Fecha a tela voltando ao dashboard do módulo atual */
  onClickCancel = () => {
    const { history } = this.props;
    const modulo = history.location.pathname.split('/')[1];

    history.push(`/${modulo}/dashboard`);
  };

  /* Atualiza o filtro de pesquisa alterado */
  onChangeSearch = (event) => {
    const { name, value } = event.target;

    this.setState(prev => ({
      searchFilter: {
        ...prev.searchFilter,
        [name]: value
      }
    }));
  };

  /* As opções push são mutuamente exclusivas, como no Desktop. */
  onChangeFiltroPush = (event) => {
    const { name, checked } = event.target;
    const outro = name === 'semConfirmacaoPushFilter'
      ? 'familiaNaoLogadaAppFilter' : 'semConfirmacaoPushFilter';
    this.setState(prev => ({
      searchFilter: { ...prev.searchFilter, [name]: checked, ...(checked ? { [outro]: false } : {}) }
    }));
  };

  /* Marca / desmarca o tipo de serviço no filtro */
  onChangeServicos = (event) => {
    const { name, checked } = event.target;

    this.setState(prev => ({
      filtrosServicos: checked ? [...prev.filtrosServicos, name] : prev.filtrosServicos.filter(
        item => item !== name
      )
    }));
  };

  /* Limpa os filtros e o resultado da pesquisa */
  limpaFiltros = () => {
    this.setState({
      filtrosServicos: [],
      searchFilter: getSearchFilterDefault(),
      whatsappErro: '',
      whatsappLimitado: false,
      whatsappResultados: []
    });
  };

  /* Pesquisa os passageiros conforme os filtros informados */
  pesquisarItensOS = async () => {
    const { filtrosServicos, searchFilter, exibirFiltrosPush } = this.state;

    this.setState({
      whatsappLoading: true,
      whatsappErro: ''
    });

    try {
      const { data } = await api.post('/crm/whatsapp/pax/pesquisar', {
        ...searchFilter,
        semConfirmacaoPushFilter: exibirFiltrosPush && searchFilter.semConfirmacaoPushFilter,
        familiaNaoLogadaAppFilter: exibirFiltrosPush && searchFilter.familiaNaoLogadaAppFilter,
        filtrosServicos
      });

      const resultados = data.resultados || [];

      this.safeSetState({
        activeTab: 1,
        whatsappLimitado: !!data.limitado,
        whatsappResultados: resultados.map(item => ({
          ...item,
          selecionado: false
        }))
      });
    } catch (error) {
      this.safeSetState({
        whatsappErro: getApiErrorMessage(error, 'Erro ao consultar os passageiros!')
      });
    } finally {
      this.safeSetState({ whatsappLoading: false });
    }
  };

  /* Marca / desmarca o passageiro da pesquisa */
  onChangePaxSelecionado = (event) => {
    const { value, checked } = event.target;
    const index = Number(value);

    this.setState(prev => ({
      whatsappResultados: prev.whatsappResultados.map((pax, i) => (
        i === index ? { ...pax, selecionado: checked } : pax
      ))
    }));
  };

  /* Marca / desmarca todos os passageiros da pesquisa */
  setSelecionadoTodos = (selecionado) => {
    this.setState(prev => ({
      whatsappResultados: prev.whatsappResultados.map(pax => ({
        ...pax,
        selecionado
      }))
    }));
  };

  /* Marca todos os passageiros da pesquisa */
  marcarTodos = () => {
    this.setSelecionadoTodos(true);
  };

  /* Desmarca todos os passageiros da pesquisa */
  desmarcarTodos = () => {
    this.setSelecionadoTodos(false);
  };

  /* Carrega os grupos de mensagem ativos */
  carregarGruposWhatsApp = async () => {
    try {
      const response = await api.get('/whatsapp/grupomensagem/active/S');

      this.safeSetState({ whatsappGrupos: getResponseData(response) });
    } catch (error) {
      this.safeSetState({
        whatsappErro: 'Não foi possível carregar os grupos de mensagem!'
      });
    }
  };

  /* Atualiza o grupo de mensagem selecionado para envio */
  onChangeGrupo = (event) => {
    this.setState({ whatsappGrupoSelecionado: event.target.value });
  };

  /* Consulta a composição (prévia) do grupo de mensagem selecionado */
  consultarComposicaoWhatsApp = async () => {
    const { whatsappGrupoSelecionado } = this.state;

    if (!whatsappGrupoSelecionado) {
      return;
    }

    this.setState({
      whatsappComposicao: null,
      whatsappDialogGrupo: true,
      whatsappPreviewLoading: true
    });

    try {
      const { data } = await api.get(
        `/crm/whatsapp/grupos/${whatsappGrupoSelecionado}/composicao`
      );

      this.safeSetState({ whatsappComposicao: data });
    } catch (error) {
      this.safeSetState({
        whatsappErro: getApiErrorMessage(error, 'Não foi possível consultar a composição!')
      });
    } finally {
      this.safeSetState({ whatsappPreviewLoading: false });
    }
  };

  /* Fecha a janela de composição do grupo de mensagens */
  handleCloseDialogGrupo = () => {
    this.setState({ whatsappDialogGrupo: false });
  };

  /* Abre a janela de gerenciamento de grupos e mensagens */
  handleOpenEstrutura = () => {
    this.setState({ whatsappDialogEstrutura: true });
  };

  /* Fecha a janela de gerenciamento de grupos e mensagens */
  handleCloseEstrutura = () => {
    this.setState({ whatsappDialogEstrutura: false });
  };

  /* Envia as mensagens do grupo selecionado aos passageiros marcados */
  enviarMensagensGrupo = async () => {
    const {
      whatsappEnviando,
      whatsappGrupoSelecionado,
      whatsappResultados
    } = this.state;

    if (whatsappEnviando) {
      return;
    }

    const selecionados = whatsappResultados.filter(pax => pax.selecionado);

    if (!selecionados.length || !whatsappGrupoSelecionado) {
      return;
    }

    const confirmado = window.confirm(
      `Enviar as mensagens do grupo para ${selecionados.length} passageiro(s)?\n` +
      'Cada reenvio será uma nova tentativa!'
    );

    if (!confirmado) {
      return;
    }

    this.setState({
      whatsappEnviando: true,
      whatsappErro: ''
    });

    try {
      const { data } = await api.post('/crm/whatsapp/enviar/grupo', {
        idGrupo: Number(whatsappGrupoSelecionado),
        destinatarios: selecionados.map(pax => ({
          coditemos: pax.coditemos,
          idpax: pax.idpax,
          fone: pax.fone
        }))
      });

      const resultados = data.resultados || [];

      const erros = resultados.filter(
        resultado => !resultado.success || resultado.registrado === false
      ).slice(0, 3).map(resultado => resultado.error).join('; ');

      this.safeSetState(prev => ({
        whatsappErro: `
          Resultado: ${data.enviados} mensagem(ns) aceita(s), ${data.falhas} falha(s). ${erros}
        `.trim(),
        whatsappResultados: prev.whatsappResultados.map(pax => {
          const retorno = resultados.filter(resultado => (
            Number(resultado.coditemos) === Number(pax.coditemos) &&
            Number(resultado.idpax) === Number(pax.idpax)
          ));

          if (!retorno.length) {
            return pax;
          }

          return {
            ...pax,
            selecionado: false,
            grupomensagem: retorno.find(r => r.registrado)?.grupomensagem || pax.grupomensagem,
            status: retorno.every(
              resultado => resultado.success
            ) ? 'Aceito pelo BSP' : 'Falha no envio!'
          };
        })
      }));
    } catch (error) {
      this.safeSetState({
        whatsappErro: getApiErrorMessage(error, 'Não foi possível enviar as mensagens!')
      });
    } finally {
      this.safeSetState({ whatsappEnviando: false });
    }
  };

  /* Renderiza um filtro de seleção da pesquisa */
  renderSelectFiltro = ({ label, minWidth, name, options }) => {
    const { searchFilter } = this.state;

    return (
      <FormControl
        key={name}
        style={{ minWidth }}
      >
        <InputLabel
          shrink
          style={{ fontSize: 13 }}
        >
          {label}
        </InputLabel>

        <Select
          native
          name={name}
          onChange={this.onChangeSearch}
          value={searchFilter[name]}
        >
          {options.map(option => (
            <option
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </Select>
      </FormControl>
    );
  };

  /* Renderiza o conteúdo da janela de composição do grupo de mensagens */
  renderComposicao = () => {
    const {
      whatsappComposicao,
      whatsappPreviewLoading
    } = this.state;

    if (whatsappPreviewLoading) {
      return <Typography>Carregando...</Typography>;
    }

    if (!whatsappComposicao) {
      return <Typography>Não foi possível carregar as mensagens!</Typography>;
    }

    const mensagens = whatsappComposicao.mensagens || [];

    return (
      <React.Fragment>
        <Typography variant="subtitle1">
          {whatsappComposicao.grupo.nome}
        </Typography>

        {mensagens.map((mensagem, i) => (
          <Paper
            key={`${mensagem.idmsgwhats}-${i}`}
            style={{
              padding: 12,
              marginTop: 12
            }}
          >
            <Typography variant="caption">
              Mensagem {i + 1} - Tipo: {mensagem.tipomensagem || 'Texto'}
            </Typography>

            <Typography
              style={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere'
              }}
            >
              {mensagem.msg || '(Sem texto)'}
            </Typography>

            {mensagem.nomearquivo &&
              <Typography variant="caption">
                Arquivo: {mensagem.nomearquivo}
              </Typography>
            }

            {mensagem.codmodelorelatorio &&
              <Typography variant="caption">
                Modelo relatório: {mensagem.codmodelorelatorio}
              </Typography>
            }
          </Paper>
        ))}

        {!mensagens.length &&
          <Typography>
            Grupo sem mensagens vinculadas!
          </Typography>
        }

        <Typography
          variant="caption"
          color="textSecondary"
          style={{
            display: 'block',
            marginTop: 16
          }}
        >
          Prévia do conteúdo cadastrado.
          Variáveis do dicionário de dados ainda não são substituídas nessa etapa.
        </Typography>
      </React.Fragment>
    );
  };

  render() {
    const {
      activeTab,
      exibirQrCodeZapi,
      exibirFiltrosPush,
      filtrosServicos,
      searchFilter,
      translations,
      whatsappDialogEstrutura,
      whatsappDialogGrupo,
      whatsappEnviando,
      whatsappErro,
      whatsappGrupos,
      whatsappGrupoSelecionado,
      whatsappLimitado,
      whatsappLoading,
      whatsappResultados
    } = this.state;

    const totalSelecionados = whatsappResultados.filter(pax => pax.selecionado).length;

    const campoHora = searchFilter.tipoDataFilter === 'dataApresentacao'
      ? 'horaapresentacao'
      : 'horainservico';

    return (
      <div>
        <AppBar
          position="static"
          color="default"
        >
          <Tabs
            value={activeTab}
            onChange={this.handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              icon={<FilterListRounded />}
              label={translations[CommonTranslations.TABSHEET_GERAL] || 'Filtros'}
            />

            <Tab
              icon={<SendRounded />}
              label="Envios"
            />

            {exibirQrCodeZapi &&
              <Tab
                icon={<CropFreeRounded />}
                label="QR Code"
              />
            }
          </Tabs>
        </AppBar>

        {/* ABA FILTROS */}
        {activeTab === 0 &&
          <TabContainer>
            <CardContent>
              {whatsappErro && <Typography color="error">{whatsappErro}</Typography>}
              {whatsappLoading && <CircularProgress size={24} />}
              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 0,
                  padding: 10,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  flexWrap: 'wrap'
                }}
              >
                {this.renderSelectFiltro(SELECT_TIPO_DATA)}

                {CAMPOS_PERIODO.map(campo => (
                  <TextField
                    key={campo.name}
                    id={campo.name}
                    name={campo.name}
                    label={campo.label}
                    type={campo.type}
                    value={searchFilter[campo.name] || ''}
                    onChange={this.onChangeSearch}
                    InputLabelProps={LABEL_PROPS_FILTRO}
                  />
                ))}

                <FormControl
                  component="fieldset"
                  style={{ minWidth: 200 }}
                >
                  <InputLabel
                    shrink
                    style={{ fontSize: 13 }}
                  >
                    Serviços
                  </InputLabel>

                  <FormGroup row>
                    {OPCOES_SERVICOS.map(servico => (
                      <FormControlLabel
                        key={servico}
                        label={
                          <span style={{ fontSize: 13 }}>
                            {servico}
                          </span>
                        }
                        control={
                          <Checkbox
                            checked={filtrosServicos.includes(servico)}
                            onChange={this.onChangeServicos}
                            name={servico}
                            color="primary"
                          />
                        }
                      />
                    ))}
                  </FormGroup>
                </FormControl>

                {SELECTS_EXIBICAO.map(this.renderSelectFiltro)}
              </Paper>

              <Paper style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 24 }}>
                <Select
                  native
                  id="situacaoOSFilter"
                  name="situacaoOSFilter"
                  onChange={this.onChangeSearch}
                  style={{ marginLeft: 20 }}
                  value={searchFilter.situacaoOSFilter}
                >
                  {OPCOES_SITUACAO_OS.map(option => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </Select>
                <FormControl component="fieldset" style={{ margin: '8px 20px' }}>
                  <FormLabel component="legend" style={{ fontSize: 13 }}>
                    Serviços escalados
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Serviços escalados"
                    name="escaladosFilter"
                    value={searchFilter.escaladosFilter}
                    onChange={this.onChangeSearch}
                  >
                    <FormControlLabel value="todos" control={<Radio color="primary" />} label="Todos" />
                    <FormControlLabel value="escalados" control={<Radio color="primary" />} label="Escalados" />
                    <FormControlLabel value="naoEscalados" control={<Radio color="primary" />} label="Não escalados" />
                  </RadioGroup>
                </FormControl>
              </Paper>

              <Paper style={{ marginTop: 10, padding: 12, display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
                {this.renderFiltroCadastro('servicos', 'codServicoFilter', 'codservico', 'descservico', 'Serviço')}
                {this.renderSelectFiltro({ name: 'tipoServicoFilter', label: 'Tipo de serviço', minWidth: 150,
                  options: [{ value: '0', label: 'Todos' }, { value: '1', label: 'Regular' }, { value: '2', label: 'Privativo' }] })}
                {this.renderFiltroCadastro('hoteis', 'codHotelFilter', 'codcliente', 'fantasia', 'Hotel / Pousada')}
                {this.renderFiltroCadastro('voos', 'codVooFilter', 'codvoo', 'descvoo', 'Voo / Rodoviário')}
                {this.renderSelectFiltro({ name: 'statusEnvioFilter', label: 'Status do envio', minWidth: 160,
                  options: [{ value: 'todos', label: 'Todos' }, { value: '0', label: 'Não enviado' },
                    { value: '1', label: 'Enviado' }, { value: '2', label: 'Recebido' }] })}
              </Paper>

              {exibirFiltrosPush && (
                <Paper style={{ marginTop: 10, padding: '12px 20px' }}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Mensagem Push</FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        label="Somente pax sem confirmação de recebimento de mensagem push"
                        control={<Checkbox color="primary" name="semConfirmacaoPushFilter"
                          checked={searchFilter.semConfirmacaoPushFilter}
                          onChange={this.onChangeFiltroPush} />}
                      />
                      <FormControlLabel
                        label="Somente pax de família não logada no app"
                        control={<Checkbox color="primary" name="familiaNaoLogadaAppFilter"
                          checked={searchFilter.familiaNaoLogadaAppFilter}
                          onChange={this.onChangeFiltroPush} />}
                      />
                    </FormGroup>
                  </FormControl>
                </Paper>
              )}

              <Paper
                style={{
                  marginBottom: 10,
                  marginTop: 10
                }}
              >
                <Input
                  autoFocus
                  id="nomePaxFilter"
                  name="nomePaxFilter"
                  onChange={this.onChangeSearch}
                  placeholder="Nome Pax"
                  value={searchFilter.nomePaxFilter}
                  style={{
                    marginBottom: 10,
                    width: 300,
                    marginLeft: 10
                  }}
                />

                {FILTROS_TEXTO.map(filtro => (
                  <TextField
                    key={filtro.name}
                    label={filtro.label}
                    name={filtro.name}
                    value={searchFilter[filtro.name] || ''}
                    onChange={this.onChangeSearch}
                    InputLabelProps={{ shrink: true }}
                    style={{
                      width: filtro.width,
                      margin: 8
                    }}
                  />
                ))}

                <Button
                  color="primary"
                  id="pesquisar"
                  onClick={this.pesquisarItensOS}
                >
                  <Search />
                </Button>

                <Button
                  color="primary"
                  onClick={this.limpaFiltros}
                >
                  <BackspaceOutlined />
                </Button>
              </Paper>
            </CardContent>
          </TabContainer>
        }

        {/* ABA ENVIOS */}
        {activeTab === 1 &&
          <TabContainer>
            <div
              style={{
                padding: 12,
                margin: 10
              }}
            >
              <Typography variant="subtitle2">
                Resultado da pesquisa: {whatsappResultados.length} passageiro(s) - {totalSelecionados} selecionado(s)
              </Typography>

              {whatsappLimitado &&
                <Typography color="error">
                  Resultado limitado a 2.000 registros. Refine os filtros!
                </Typography>
              }

              <Button
                color="primary"
                onClick={this.handleVoltarFiltros}
              >
                Voltar aos filtros
              </Button>

              <Button
                color="primary"
                onClick={this.marcarTodos}
              >
                Marcar todos
              </Button>

              <Button onClick={this.desmarcarTodos}>
                Desmarcar todos
              </Button>

              {whatsappLoading &&
                <CircularProgress
                  size={24}
                />
              }

              {whatsappErro &&
                <Typography color="error">
                  {whatsappErro}
                </Typography>
              }

              <Paper
                style={{
                  overflowX: 'auto',
                  maxHeight: 420,
                  overflowY: 'auto'
                }}
              >
                <Table
                  size="small"
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      {COLUNAS_PASSAGEIROS.map(coluna => (
                        <TableCell key={coluna}>
                          {coluna}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {whatsappResultados.map((pax, i) => (
                      <TableRow key={`${pax.coditemos}-${pax.idpax}-${i}`}>
                        <TableCell>
                          <Checkbox
                            checked={pax.selecionado}
                            onChange={this.onChangePaxSelecionado}
                            value={i}
                          />
                        </TableCell>

                        <TableCell>{pax.nomepax}</TableCell>

                        <TableCell>{pax.fone}</TableCell>

                        <TableCell>{pax.nroos}</TableCell>

                        <TableCell>{formatDateText(pax.dataservico)}</TableCell>

                        <TableCell>{formatTimeText(pax[campoHora])}</TableCell>

                        <TableCell>{pax.descservico}</TableCell>

                        <TableCell>{pax.hotel}</TableCell>

                        <TableCell>{pax.localorigem}</TableCell>

                        <TableCell>{({ 0: 'Não enviado', 1: 'Enviado', 2: 'Recebido' })[pax.status] || pax.status || 'Não enviado'}</TableCell>

                        <TableCell>{pax.grupomensagem || ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </div>

            <Paper
              style={{
                padding: 16,
                margin: '12px 10px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 20
              }}
            >
              <FormControl
                style={{
                  minWidth: 240,
                  maxWidth: 380,
                  flex: '1 1 240px'
                }}
              >
                <InputLabel shrink>
                  Grupo de mensagem para envio
                </InputLabel>

                <Select
                  native
                  value={whatsappGrupoSelecionado}
                  onChange={this.onChangeGrupo}
                >
                  <option value="">
                    Selecione o grupo
                  </option>

                  {whatsappGrupos.map(grupo => (
                    <option
                      key={grupo.idgrupomsgwhats}
                      value={grupo.idgrupomsgwhats}
                    >
                      {grupo.nome}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <WhatsAppEstrutura
                open={whatsappDialogEstrutura}
                onClose={this.handleCloseEstrutura}
                onChanged={this.carregarGruposWhatsApp}
              />

              <Dialog
                open={whatsappDialogGrupo}
                onClose={this.handleCloseDialogGrupo}
                fullWidth
                maxWidth="md"
              >
                <DialogTitle>Composição do grupo de mensagens</DialogTitle>

                <DialogContent>
                  {this.renderComposicao()}
                </DialogContent>

                <DialogActions>
                  <Button onClick={this.handleCloseDialogGrupo}>
                    Fechar
                  </Button>
                </DialogActions>
              </Dialog>

              <Button
                color="primary"
                disabled={!whatsappGrupoSelecionado}
                onClick={this.consultarComposicaoWhatsApp}
              >
                Ver composição / prévia
              </Button>

              <Button
                color="primary"
                onClick={this.handleOpenEstrutura}
              >
                Gerenciar grupos e mensagens
              </Button>

              <Button
                variant="contained"
                color="primary"
                startIcon={<WhatsApp />}
                disabled={whatsappEnviando || !whatsappGrupoSelecionado || !totalSelecionados}
                onClick={this.enviarMensagensGrupo}
              >
                Enviar mensagens
              </Button>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 16
                }}
              >
                {LEGENDA_STATUS.map(status => (
                  <span
                    key={status.label}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 5
                    }}
                  >
                    <span
                      style={{
                        width: 14,
                        height: 14,
                        border: status.border,
                        borderRadius: '50%',
                        background: status.background
                      }}
                    />

                    {status.label}
                  </span>
                ))}
              </div>
            </Paper>
          </TabContainer>
        }

        {/* ABA QR CODE */}
        {activeTab === 2 && exibirQrCodeZapi &&
          <TabContainer>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Dispositivo não conectado
              </FormLabel>
            </FormControl>
          </TabContainer>
        }

        <div>
          <ButtonA2X
            variant="contained"
            color="secondary"
            onClick={this.onClickCancel}
          >
            Fechar
          </ButtonA2X>
        </div>
      </div>
    );
  };
};

export default EnvioWhatsAppPassageiroForm;